<div class="jeopardy-app">
  <div>
    @if (!isMainPage()) {
      <jeopardy-logo></jeopardy-logo>
    }
  </div>
  <div class="route-shell" [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>


<jeopardy-confetti></jeopardy-confetti>

<jeopardy-loader></jeopardy-loader>


